export default {
	"subscribe.CardClick": "Card click",
	"subscribe.checkTheDetails": "check the details",
	"subscribe.subscribing": "subscribing",
	"subscribe.continueToSubscribe": "continue to subscribe",
	"subscribe.Paused": "Paused",
	"subscribe.TurnOnRenewal": "Turn on renewal",
	"subscribe.expired": "expired",
	"subscribe.completed": "completed",
	"subscribe.ViewDeductionRecords": "View deduction records",
	"subscribe.UnfortunatelyNoMatchingDataWasFound": "Unfortunately, no matching data was found"
}